import script from "./whatsappConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./whatsappConfig.vue?vue&type=script&lang=ts&setup=true"

import "./whatsappConfig.vue?vue&type=style&index=0&id=223ba4d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-223ba4d6"]])

export default __exports__